<template>
  <div class="column">
    <woot-modal-header :header-title="$t('WEBHOOKS_SEND_MESSAGES.EDIT.TITLE')" :header-content="$t('WEBHOOKS_SEND_MESSAGES.EDIT.DESC')" />
    <webhook-form
      :is-submitting="uiFlags.isUpdating"
      @submit="onSubmit"
      :value="value"     
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import TemplatesPicker from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplatesPicker';
import TemplateParser from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplateParser';
import WebhookForm from './Form';

import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  components: {
    TemplatesPicker,
    TemplateParser,
    MultiselectDropdown,
    WootMessageEditor,
    WebhookForm,
  },
  props: {
    value: {
      type: Object,
      required: true,
    }
  },  
  computed: {
    ...mapGetters({
      uiFlags: 'webhooksSendMessages/getUIFlags',
    }),
    inboxes() {
      return this.$store.getters['inboxes/getWhatsAppInboxes'];
    },
  },
  methods: {
    ...mapActions('webhooksSendMessages', ['update']),
    async onSubmit(webhook) {
      try {
        await this.update({ data: webhook, id: this.value.id });

        this.showAlert(this.$t('WEBHOOKS_SEND_MESSAGES.EDIT.API.SUCCESS_MESSAGE'));
        this.$emit('on-updated');
      } catch (error) {
        this.showAlert(this.$t('WEBHOOKS_SEND_MESSAGES.EDIT.API.ERROR_MESSAGE'));
      } finally {
        this.onClose();
      }
    },
    onClose() {
      this.$emit('on-close');
    }    
  }  
};
</script>